// IMPORTS
import React, { useContext, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CustomInput from "./CustomInput";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { UserContext } from "../../context/UserProvider";
import AccountsList from "./AccountsList";
import AccountSettings from "./AccountSettings";

//APP
export default function SettingsCard(props) {
  //TAB STATES
  const [value, setValue] = useState("myprofile");
  const [isEdit, setIsEdit] = useState(true);
  const { user: userData, loading } = useContext(UserContext);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // GENDER SELECT STATES
  const genderSelect = [
    {
      value: "male",
      label: "Male",
    },
    {
      value: "female",
      label: "Female",
    },
  ];

  // FORM STATES
  const [user, setUser] = useState({
    // DEFAULT VALUES
    firstName: "",
    lastName: "",
    gender: "",
    phone: "",
    email: "",
    pass: "",
    showPassword: false,
  });

  useEffect(() => {
    if (userData) {
      setUser({
        firstName: userData.agentName,
        phone: userData.contact,
        email: userData.email,
      });
    }
  }, [userData]);

  const changeField = (event) => {
    setUser({ ...user, [event.target.name]: event.target.value });
  };

  // EDIT -> UPDATE
  const changeButton = (event) => {
    event.preventDefault();
    user.showPassword = false;

    console.log("user: ", user);
  };

  // TOGGLE PASSWORD VISIBILITY
  const handlePassword = () => {
    user.showPassword = !user.showPassword;
  };

  //RETURN
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
      >
        <Tab value="myprofile" label="My Profile" />
        <Tab value="accountslist" label="Accounts List" />
        <Tab value="settings" label="Settings" />
      </Tabs>
      <Divider />
      <CardContent
        sx={{
          p: 3,
          textAlign: { xs: "center", md: "start" },
        }}
      >
        {value === "myprofile" && (
          <>
            <FormControl fullWidth>
              <Grid
                container
                direction={{ xs: "column", md: "row" }}
                columnSpacing={4}
                rowSpacing={1}
              >
                {/* ROW 1: FIRST NAME */}
                <Grid component="form" item xs={6}>
                  <CustomInput
                    disabled={!isEdit}
                    id="firstName"
                    name="firstName"
                    value={user.firstName}
                    onChange={changeField}
                    title="First Name"
                  />
                </Grid>

                {/* ROW 1: LAST NAME */}
                <Grid component="form" item xs={6}>
                  <CustomInput
                    disabled={!isEdit}
                    id="lastName"
                    name="lastName"
                    value={user.lastName}
                    onChange={changeField}
                    title="Last Name"
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomInput
                    disabled={!isEdit}
                    select
                    id="gender"
                    name="gender"
                    value={user.gender}
                    onChange={changeField}
                    title="Gender"
                    //MAP THRU OPTIONS
                    content={genderSelect.map((option) => (
                      <MenuItem value={option.value}>{option.label}</MenuItem>
                    ))}
                  />
                </Grid>

                {/* ROW 3: PHONE */}
                <Grid item xs={6}>
                  <CustomInput
                    disabled={!isEdit}
                    id="phone"
                    name="phone"
                    value={user.phone}
                    onChange={changeField}
                    title="Phone Number"
                    //DIALING CODE
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">91</InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* ROW 3: EMAIL */}
                <Grid item xs={6}>
                  <CustomInput
                    disabled={!isEdit}
                    type="email"
                    id="email"
                    name="email"
                    value={user.email}
                    onChange={changeField}
                    title="Email Address"
                  />
                </Grid>

                <Grid item xs={6}>
                  <CustomInput
                    disabled={!isEdit}
                    id="pass"
                    name="pass"
                    value={user.pass}
                    onChange={changeField}
                    title="Password"
                    type={user.showPassword ? "text" : "password"}
                    // PASSWORD ICON
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={handlePassword}
                            edge="end"
                          >
                            {user.showPassword ? (
                              <VisibilityOff fontSize="small" />
                            ) : (
                              <Visibility fontSize="small" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </FormControl>
            <Box display={"flex"} justifyContent={"end"}>
              <Button variant="contained" startIcon={<EditIcon />}>
                Save
              </Button>
            </Box>
          </>
        )}
        {value === "accountslist" && <AccountsList />}
        {value === "settings" && <AccountSettings />}
      </CardContent>
    </Card>
  );
}
